import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import { getContrastingTextColor } from '../../util/ColorUtil';

export default class ColoredLabel extends Component {
  static propTypes = {
    color: PropTypes.string
  };

  static defaultProps = {
    color: null
  };

  render() {
    const { color, children, className } = this.props;

    const classes = cx('label', className);

    let colorHex = color;
    if (typeof colorHex === 'string') {
      if (colorHex.length > 0 && colorHex[ 0 ] !== '#') {
        colorHex = `#${colorHex}`;
      }
    } else {
      colorHex = '#ffffff';
    }

    const backgroundColor = colorHex || 'black';
    const style = { backgroundColor, color: getContrastingTextColor(colorHex) };

    return (
      <span className={classes} style={style}>{children}</span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/ColoredLabel.jsx